<template>
  <div>
    <v-container fluid grid-list-md>
      <v-layout row wrap>
        <v-flex lg12 md12 xl12 xs12>
          <v-card>
            <v-card-title primary-title>
              <h2 class="display-1 mb-0">Teilnehmer {{ participant.firstname }} {{ participant.lastname }}</h2>
            </v-card-title>
            <v-card-text>
              <v-layout row wrap>
                <v-flex lg6 md6 xl6 xs12>
                  <v-form ref="participant" v-model="formValid">
                    <v-container grid-list-md>
                      <v-layout row wrap>
                        <v-flex xs12><h3 class="headline mb-0">Daten</h3></v-flex>
                      </v-layout>
                      <v-layout row wrap>
                        <v-flex xs4>
                          <v-radio-group
                              :rules="[rules.required]"
                              label="Anrede"
                              name="gender"
                              row
                              v-model="participant.gender">
                            <v-radio color="secondary" label="Herr" value="male"></v-radio>
                            <v-radio color="secondary" label="Frau" value="female"></v-radio>
                          </v-radio-group>
                        </v-flex>
                      </v-layout>

                      <v-layout row wrap>
                        <v-flex xs6>
                          <v-text-field :rules="[rules.required]" label="Vorname"
                                        v-model="participant.firstname"></v-text-field>
                        </v-flex>
                        <v-flex xs6>
                          <v-text-field :rules="[rules.required]" label="Nachname"
                                        v-model="participant.lastname"></v-text-field>
                        </v-flex>
                      </v-layout>
                      <v-layout row wrap>
                        <v-flex xs6>
                          <v-text-field :rules="[rules.required]" label="Straße"
                                        v-model="participant.street"></v-text-field>
                        </v-flex>
                        <v-flex xs2>
                          <v-text-field :rules="[rules.required]" label="Postleizahl"
                                        v-model="participant.postal"></v-text-field>
                        </v-flex>
                        <v-flex xs4>
                          <v-text-field :rules="[rules.required]" label="Ort" v-model="participant.city"></v-text-field>
                        </v-flex>
                      </v-layout>
                      <v-layout row wrap>
                        <v-flex xs6>
                          <v-text-field :rules="[rules.required]" label="Land"
                                        v-model="participant.country"></v-text-field>
                        </v-flex>
                        <v-flex xs4>
                          <v-text-field :rules="[rules.required]" label="E-Mail"
                                        v-model="participant.email"></v-text-field>
                        </v-flex>
                      </v-layout>
                      <v-layout row wrap>
                        <v-flex xs12>
                          <v-textarea v-model="participant.comment" label="Kommentar"></v-textarea>
                        </v-flex>
                      </v-layout>
                      <v-layout row wrap>
                        <v-flex xs12>
                          <v-select
                              :items="categories"
                              :rules="[rules.required]"
                              item-value="id"
                              label="Kategorie"
                              name="category"
                              prepend-icon="fal fa-clipboard-list-check"
                              v-model="participant.category"
                          >
                            <template
                                slot="selection"
                                slot-scope="category"
                            >
                              {{ category.item.title }}
                            </template>
                            <template
                                slot="item"
                                slot-scope="category"
                            >
                              {{ category.item.title }}
                            </template>
                          </v-select>
                        </v-flex>
                      </v-layout>
                      <v-layout row wrap>
                        <v-flex xs4>
                          <v-text-field :rules="[rules.required]" label="Telefon"
                                        v-model="participant.phone"></v-text-field>
                        </v-flex>
                        <v-flex xs4>
                          <v-switch :rules="[rules.requiredIfStart]" label="Telefonnummer überprüft" v-model="participant.phoneVerified"></v-switch>
                        </v-flex>
                      </v-layout>
                      <v-layout row wrap>
                        <v-flex xs2>
                          <v-text-field :rules="[rules.required]" label="Geburtstag"
                                        v-model="participant.dateOfBirth"></v-text-field>
                        </v-flex>
                        <v-flex xs2>
                          <v-text-field :value="age + ' Jahre'"></v-text-field>
                        </v-flex>
                        <v-flex xs4>
                          <v-switch :rules="[rules.requiredIfStart]" label="Geburtsdatum überprüft" v-model="participant.dateOfBirthVerified"></v-switch>
                        </v-flex>
                      </v-layout>
                      <v-layout row wrap>
                        <v-flex xs6>
                          <v-text-field label="Startnummer" :rules="[rules.startNumber]"
                                        v-model="participant.startNumber" :disabled="participant.canceled"></v-text-field>
                        </v-flex>
                      </v-layout>
                      <v-layout row wrap v-if="participant.lastCheckpointTime !== null && participant.canceled !== true">
                        <v-flex xs12>
                          <h3>Zeit Zieleinlauf</h3>
                        </v-flex>
                        <v-flex xs12>
                          <v-date-picker v-model="lastCheckpointDate" :first-day-of-week="1" locale="de-DE" landscape color="secondary" :min="categoryStartDate"></v-date-picker>
                        </v-flex>
                        <v-flex xs12>
                          <v-time-picker v-model="lastCheckpointTime" landscape format="24hr" color="secondary"></v-time-picker>
                        </v-flex>
                      </v-layout>
                      <v-layout row wrap>
                        <v-flex xs12>
                      <v-alert color="warning" v-model="participant.canceled">
                        Teilnehmer hat abgebrochen bzw. die Teilnehme vorher abgesagt.
                      </v-alert>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-form>
                </v-flex>
                <v-flex lg6 md6 v-if="id > 0" xl6 xs12>
                  <Payment :participant="participant"></Payment>
                  <ParticipantProgress :participant="participant" v-if="participant.running"></ParticipantProgress>

                  <v-container grid-list-md>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <h3 class="headline mb-0">Log</h3>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                      <v-flex xs8>Registrierung</v-flex>
                      <v-flex xs4>{{ participant.registrationDate }}</v-flex>
                    </v-layout>
                    <!--
                    <v-layout row wrap>
                      <v-flex xs8>Bestätigungsmail</v-flex>
                      <v-flex xs4>{{ participant.confirmationMailDate }}</v-flex>
                    </v-layout>
                    <v-layout row wrap>
                      <v-flex xs8>Zahlungserinnerung</v-flex>
                      <v-flex xs4>{{ participant.paymentReminderMailDate }}</v-flex>
                    </v-layout>
                    -->
                    <v-layout row wrap>
                      <v-flex xs8>Geldeingang</v-flex>
                      <v-flex xs4>{{ participant.paymentFulfilledDate }}</v-flex>
                    </v-layout>
                    <v-layout row wrap v-if="participant.canceled">
                      <v-flex xs8>Teilnahme abgesagt/abgebrochen</v-flex>
                      <v-flex xs4>{{ participant.cancelDate }}</v-flex>
                    </v-layout>
                  </v-container>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-btn @click="saveParticipant" color="primary">
                Speichern
              </v-btn>
              <v-btn @click="saveParticipantAndBack" color="primary">
                Speichern und zur Übersicht
              </v-btn>
              <v-btn @click="sendConfirmationMail" color="info">
                Bestätigungsmail senden
              </v-btn>
              <v-btn @click="cancelParticipant" color="error">
                Teilnahme absagen
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <v-snackbar :color="snackbar.color" bottom right v-model="snackbar.display">
      {{ snackbar.message }}
      <v-btn @click="snackbar.display = false" flat>
        <v-icon>fal fa-times</v-icon>
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
  import Payment from "../components/Payment";
  import ParticipantService from "../services/ParticipantService";
  import ParticipantProgress from "../components/ParticipantProgress";

  export default {
    components: {ParticipantProgress, Payment},
    props: {'id': Number},
    computed: {
      category() {
        return this.categories.find(category => category.id === this.participant.category)
      },
      categoryStartDate() {
        if (this.id === 0 || this.category.startTime === null) {
          return new Date()
        }
        let date = this.category.startTime.split(' ');
        return date[0].split('.').reverse().join('-');
      },
      event() {
        return this.$store.state.event
      },
      participants() {
        return this.$store.state.participants
      },
      categories() {
        if (this.id === 0) {
          return this.$store.state.categories.filter(category => category.startTime === null)
        }
        return this.$store.state.categories
      },
      participant() {
        let participant = this.$store.state.participants.find(item => item.id === this.id)
        if (participant !== undefined) {
          return participant
        }

        return {
          category: 0,
          gender: null,
          firstname: '',
          lastname: '',
          email: '',
          phone: '',
          phoneVerified: false,
          street: '',
          postal: '',
          city: '',
          country: '',
          dateOfBirth: null,
          startNumber: null,
          canceled: false,
          comment: null,
          lastCheckpointTime: null,
        }
      },
      age () {
        if (this.participant.dateOfBirth !== null) {
          const dateOfBirth = new Date(this.participant.dateOfBirth.split('.').reverse().join('-'))
          const ageDate = new Date(Date.now() - dateOfBirth.getTime());
          return Math.abs(ageDate.getUTCFullYear() - 1970);
        }
        return 0
      }
    },
    data: function () {
      return {
        lastCheckpointTime: null,
        lastCheckpointDate: null,
        formValid: null,
        snackbar: {
          display: false,
          message: '',
          color: 'success'
        },
        rules: {
          required: value => !!value || 'Pflichtfeld',
          requiredIfStart: value => this.participant.startNumber === '' || this.participant.startNumber === null || !!value || 'Pflichtfeld',
          streetNumber: value => {
            const pattern = /^[0-9]+[ a-zA-Z]{0,2}$/
            return pattern.test(value) || 'Keine korrekte Hausnummer'
          },
          numberOnly: value => {
            const pattern = /^[0-9]+$/
            if (value === undefined || value === '') {
              return true
            } else if (pattern.test(value) && value > 0) {
              return true
            }
            return 'Bitte geben Sie nur Zahlen >= 1 ein.'
          },
          email: value => {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return pattern.test(value) || 'Bitte geben Sie eine gültige E-Mailadresse ein.'
          },
          startNumber: value => {
            if (value === undefined || value === '') {
              return true
            } else if (value !== undefined && value !== '' && this.participants.find(participant => participant.startNumber === value && participant.id !== this.id) !== undefined) {
              return 'Startnummer ist bereits vergeben.'
            }
            return true
          }
        }
      }
    },
    methods: {
      saveParticipant() {
        if (this.$refs.participant.validate()) {
          return new Promise((resolve, reject) => {
            this.participant.eventId = this.event.id
            if (this.lastCheckpointDate !== null && this.lastCheckpointTime !== null) {
              this.participant.lastCheckpointTime = this.lastCheckpointDate + ' ' + this.lastCheckpointTime
            } else {
              this.participant.lastCheckpointTime = null
            }

            if (this.id > 0) {
              this.$store.dispatch('saveParticipant', this.participant).then(() => {
                this.snackbar.display = true
                this.snackbar.message = 'Teilnehmer wurde gespeichert.'
                this.snackbar.color = 'success'
                resolve()
              }).catch(() => {
                this.snackbar.display = true
                this.snackbar.message = 'Teilnehmer konnte nicht gespeichert.'
                this.snackbar.color = 'error'
                reject()
              })
            } else {
              this.$store.dispatch('addParticipant', this.participant).then(id => {
                this.snackbar.display = true
                this.snackbar.message = 'Teilnehmer wurde hinzugefügt.'
                this.snackbar.color = 'success'
                resolve()
                this.$router.push({name: 'participant', params: {id: id}})
              }).catch(() => {
                this.snackbar.display = true
                this.snackbar.message = 'Teilnehmer konnte nicht angelegt werden.'
                this.snackbar.color = 'error'
                reject()
              })
            }
          })
        } else {
          return new Promise((resolve, reject) => {
            this.snackbar.display = true
            this.snackbar.message = 'Es sind noch fehlerhafte Felder vorhanden.'
            this.snackbar.color = 'error'
            reject()
          })
        }
      },
      saveParticipantAndBack() {
        this.saveParticipant().then(() => {
          this.$router.push({name: 'participants'})
        })
      },
      cancelParticipant() {
        if (confirm('Sind Sie sicher, dass Sie die Teilnahme absagen möchten?')) {
          this.participant.canceled = true
          this.saveParticipant().then(() => {
            this.$router.push({name: 'participants'})
          })
        }
      },
      sendConfirmationMail() {
        ParticipantService.sendConfirmationMail(this.participant).then(() => {
          this.snackbar.display = true
          this.snackbar.message = 'Bestätungsmail wurde versendet.'
          this.snackbar.color = 'success'
        }).catch(() => {
          this.snackbar.display = true
          this.snackbar.message = 'Bestätigungsmail konnte nicht versendet werden.'
          this.snackbar.color = 'error'
        })
      }
    },
    mounted() {
      if (this.id > 0 && this.participant.lastCheckpointTime !== null) {
        const date = this.participant.lastCheckpointTime.split(' ')
        this.lastCheckpointDate = date[0]
        this.lastCheckpointTime = date[1]
      }
    }
  }
</script>
